import KibLabel from '@chewy/kib-label-react'
import type { Constant } from '@pbt/pbt-ui-components'

import {
  type RxDisplayStatus,
  RxDisplayStatusLabel,
  RxDisplayStatusToVariant,
} from '~/constants/rxStatusChip'
import type { Prescription } from '~/types/entities/prescriptions'
import { getRxDisplayStatus } from '~/utils/rxStatusChipUtils'

import '@chewy/kib-label-styles/dist/kib-label.css'

export interface RxStatusChipProps {
  className?: string
  prescription?: Prescription
  prescriptionStates?: Constant[]
  status?: RxDisplayStatus
}

function computeDisplayStatus(
  prescription: Prescription,
  prescriptionStates: Constant[] | undefined,
): RxDisplayStatus | undefined {
  return (
    getRxDisplayStatus(
      {
        stateId: prescription.stateId,
        rejectionReason: prescription.rejectionReason,
        expirationDate: prescription.refillExpirationDate,
      },
      prescriptionStates,
    ) ?? undefined
  )
}

const RxStatusChip = ({
  status,
  prescription,
  prescriptionStates = [],
  className,
}: RxStatusChipProps) => {
  const displayStatus =
    status ??
    (prescription
      ? computeDisplayStatus(prescription, prescriptionStates)
      : undefined)

  if (!displayStatus) return null

  return (
    <KibLabel
      className={className}
      variant={RxDisplayStatusToVariant[displayStatus]}
    >
      {RxDisplayStatusLabel[displayStatus]}
    </KibLabel>
  )
}

export default RxStatusChip
